export const DATE_OF_INSURANCE_START_MAX_DAYS = 365;
